var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg166Hourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.127,240.903c4.767-4.147,10.218-8.729,15.99-13.581C392.692,191.533,451,142.519,451,91V60c0-33.084-26.916-60-60-60 H121C87.916,0,61,26.916,61,60v31c0,51.519,58.308,100.533,100.883,136.323c5.772,4.852,11.223,9.434,15.99,13.581 c4.529,3.941,7.127,9.443,7.127,15.097c0,5.653-2.597,11.155-7.127,15.096c-4.767,4.147-10.218,8.729-15.99,13.581 C119.308,320.467,61,369.481,61,421v31c0,33.084,26.916,60,60,60h270c33.084,0,60-26.916,60-60c0-11.046-8.954-20-20-20 c-11.046,0-20,8.954-20,20c0,11.028-8.972,20-20,20H121c-11.028,0-20-8.972-20-20v-31c0-32.888,54.224-78.469,86.621-105.704 c5.905-4.963,11.483-9.652,16.506-14.022C217.392,289.733,225,273.231,225,256c0-17.232-7.608-33.734-20.872-45.275 c-5.023-4.369-10.601-9.058-16.506-14.022C155.224,169.469,101,123.888,101,91V60c0-11.028,8.972-20,20-20h270 c11.028,0,20,8.972,20,20v31c0,32.888-54.224,78.469-86.621,105.703c-5.905,4.963-11.483,9.652-16.506,14.022 C294.608,222.266,287,238.768,287,256s7.608,33.734,20.872,45.274c5.235,4.553,11.067,9.435,17.242,14.604 c19.458,16.287,41.511,34.747,58.918,54.387c7.326,8.266,19.966,9.027,28.233,1.702c8.266-7.326,9.028-19.966,1.702-28.233 c-19.383-21.87-43.667-42.196-63.179-58.529c-6.024-5.043-11.715-9.806-16.661-14.109C329.598,267.155,327,261.653,327,256 S329.598,244.844,334.127,240.903z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg166Hourglass);
export default __webpack_public_path__ + "static/media/166-hourglass.3ce926516a6b0dd31ac4fca4163f7f3e.svg";
export { ForwardRef as ReactComponent };